import { render, staticRenderFns } from "./PrinterRelatorio.vue?vue&type=template&id=1fb4221a&"
import script from "./PrinterRelatorio.vue?vue&type=script&lang=js&"
export * from "./PrinterRelatorio.vue?vue&type=script&lang=js&"
import style0 from "./PrinterRelatorio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports